import React from 'react';

import styles from './form-item.module.css';

export const HelpText: React.FC<React.HtmlHTMLAttributes<HTMLSpanElement>> = ({children}) => {

  return (
    <span className={styles.help}>
      {children}
    </span>
  )
};
